import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '~/app/store'
import { hasUserPermission } from '~/shared/lib/permissions'
import { NavigationProps } from './types'
import { navigation } from './config'
import { NavMenuItem } from '../nav-item'
import { menuLinks } from '~/shared/lib'

export const Navigation: FC<NavigationProps> = observer(({ className }) => {
  const {
    usersStore: { userProfile },
  } = useStore()
  return (
    <ul className={navigation({ className })}>
      {menuLinks
        .filter(
          (item) =>
            !item.requiredPermission ||
            hasUserPermission(userProfile, item.requiredPermission),
        )
        .map((item) => ({
          ...item,
          subLinks: item.subLinks?.filter(
            (link) =>
              !link.requiredPermission ||
              hasUserPermission(userProfile, link.requiredPermission),
          ),
        }))
        .map((item, i) => (
          <NavMenuItem key={item.link} item={item} index={i + 1} />
        ))}
    </ul>
  )
})
